const scienceSection = document.querySelector(".js-science-circadian");
const scienceContent = document.querySelector(".js-science-circadian-content");
const scienceSwitchElement = document.querySelector("#science-switch");
const scienceIcon = document.querySelector(".js-science-circadian-icon");
const scienceIconMobile = document.querySelector(
  ".js-science-circadian-icon-mobile"
);

if (scienceSwitchElement) {
  scienceSwitchElement.addEventListener("change", () => {
    if (scienceSwitchElement.checked) {
      scienceSection.classList.add("is-active");
      scienceIcon.classList.add("is-active");
      scienceIconMobile.classList.add("is-active");
      scienceContent.style.setProperty("--switch-color", "#7beeff");
    } else {
      scienceSection.classList.remove("is-active");
      scienceIcon.classList.remove("is-active");
      scienceIconMobile.classList.remove("is-active");
      scienceContent.style.setProperty("--switch-color", "#001a41");
    }
  });
}
